{
  "familyId": "TGL-GELD-KOOPJES",
  "questions": [
    {
      "id": "TGL-GELD-KOOPJES-001",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "3 appels kosten €1,50. 5 appels kosten €2,00. Welke aanbieding is goedkoper per appel?",
      "options": [
        "5 appels voor €2,00",
        "3 appels voor €1,50",
        "beide even duur",
        "kan je niet uitrekenen"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_apples",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per stuk berekenen",
            "content": "Deel de prijs door het aantal. 3 appels: €1,50 ÷ 3 = €0,50 per appel. 5 appels: €2,00 ÷ 5 = €0,40 per appel. €0,40 < €0,50 → 5 appels is goedkoper per stuk.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken de prijs per stuk door de totaalprijs te delen door het aantal. Stap 1: 3 appels: €1,50 ÷ 3 = €0,50 per appel. Stap 2: 5 appels: €2,00 ÷ 5 = €0,40 per appel. Stap 3: vergelijk: €0,40 < €0,50, dus 5 appels voor €2,00 is goedkoper per appel.",
        "distractorExplanations": {
          "0": "Correct! €2,00 ÷ 5 = €0,40 per appel — goedkoper dan €1,50 ÷ 3 = €0,50.",
          "1": "Veelgemaakte fout: alleen naar de totaalprijs kijken. €1,50 is minder dan €2,00, maar per appel is het duurder: €1,50 ÷ 3 = €0,50 vs. €2,00 ÷ 5 = €0,40. Vergelijk altijd de prijs per stuk.",
          "2": "Veelgemaakte fout: denken dat het niet uitmaakt. Ze zijn niet even duur per stuk: €0,50 vs. €0,40 per appel. Dat is 10 cent verschil.",
          "3": "Veelgemaakte fout: denken dat je het niet kunt uitrekenen. Deel de prijs door het aantal: €1,50 ÷ 3 = €0,50 en €2,00 ÷ 5 = €0,40. Dan vergelijk je."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-002",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een pak van 6 yoghurtjes kost €3,00. Losse yoghurtjes kosten €0,60 per stuk. Hoeveel bespaar je per yoghurtje als je het pak koopt?",
      "options": [
        "€0,10",
        "€0,20",
        "€0,50",
        "€0,05"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_savings",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Besparing per stuk berekenen",
            "content": "Pakprijs per stuk: €3,00 ÷ 6 = €0,50. Losse prijs: €0,60. Besparing: €0,60 − €0,50 = €0,10 per yoghurtje.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken de prijs per stuk in het pak en vergelijk met de losse prijs. Stap 1: pakprijs per yoghurtje: €3,00 ÷ 6 = €0,50. Stap 2: losse prijs: €0,60. Stap 3: besparing = €0,60 − €0,50 = €0,10 per yoghurtje.",
        "distractorExplanations": {
          "0": "Correct! €3,00 ÷ 6 = €0,50 per stuk. Besparing: €0,60 − €0,50 = €0,10.",
          "1": "Veelgemaakte fout: de deling verkeerd uitvoeren. €3,00 ÷ 6 = €0,50 (niet €0,40). Besparing: €0,60 − €0,50 = €0,10, niet €0,20.",
          "2": "Veelgemaakte fout: de pakprijs per stuk verwarren met de besparing. €0,50 is de prijs per yoghurtje in het pak, niet de besparing. Besparing = losse prijs − pakprijs = €0,60 − €0,50 = €0,10.",
          "3": "Veelgemaakte fout: de deling verkeerd uitvoeren. €3,00 ÷ 6 = €0,50 (niet €0,55). Besparing: €0,60 − €0,50 = €0,10, niet €0,05."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-003",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Winkel A verkoopt een pen voor €1,20. Winkel B heeft een aanbieding: 3 pennen voor €3,00. Waar is één pen goedkoper?",
      "options": [
        "Winkel B",
        "Winkel A",
        "beide even duur",
        "Winkel B is duurder"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_stores",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per pen vergelijken",
            "content": "Winkel A: €1,20 per pen. Winkel B: €3,00 ÷ 3 = €1,00 per pen. €1,00 < €1,20 → Winkel B is goedkoper per pen.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken de prijs per stuk bij beide winkels en vergelijk. Stap 1: Winkel A: €1,20 per pen. Stap 2: Winkel B: €3,00 ÷ 3 = €1,00 per pen. Stap 3: vergelijk: €1,00 < €1,20, dus Winkel B is goedkoper per pen.",
        "distractorExplanations": {
          "0": "Correct! Winkel B: €3,00 ÷ 3 = €1,00 per pen. Dat is 20 cent goedkoper dan €1,20 bij Winkel A.",
          "1": "Veelgemaakte fout: alleen naar de prijs per stuk kijken zonder te vergelijken. Winkel A = €1,20/pen, Winkel B = €1,00/pen. €1,00 < €1,20, dus Winkel B is goedkoper.",
          "2": "Veelgemaakte fout: denken dat het niet uitmaakt. €1,20 ≠ €1,00. Dat is 20 cent verschil per pen.",
          "3": "Veelgemaakte fout: alleen naar de totaalprijs kijken. €3,00 is meer dan €1,20, maar per pen is Winkel B goedkoper: €3,00 ÷ 3 = €1,00 < €1,20."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-004",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een fles sap van 1 liter kost €2,00. Een fles van 2 liter kost €3,50. Welke is goedkoper per liter?",
      "options": [
        "2 liter fles",
        "1 liter fles",
        "beide even duur",
        "kan je niet vergelijken"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_volume",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per liter berekenen",
            "content": "1 liter fles: €2,00 ÷ 1 = €2,00/liter. 2 liter fles: €3,50 ÷ 2 = €1,75/liter. €1,75 < €2,00 → 2 liter fles is goedkoper per liter.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken de prijs per liter door de totaalprijs te delen door het aantal liters. Stap 1: 1 liter fles: €2,00 ÷ 1 = €2,00/liter. Stap 2: 2 liter fles: €3,50 ÷ 2 = €1,75/liter. Stap 3: vergelijk: €1,75 < €2,00, dus de 2 liter fles is goedkoper per liter.",
        "distractorExplanations": {
          "0": "Correct! 2 liter fles: €3,50 ÷ 2 = €1,75/liter. Dat is 25 cent goedkoper per liter.",
          "1": "Veelgemaakte fout: alleen naar de totaalprijs kijken. €2,00 is minder dan €3,50, maar per liter is de 1 liter fles duurder: €2,00/liter vs. €1,75/liter.",
          "2": "Veelgemaakte fout: denken dat het niet uitmaakt. €2,00/liter ≠ €1,75/liter. Dat is 25 cent verschil per liter.",
          "3": "Veelgemaakte fout: denken dat je het niet kunt vergelijken. Deel de prijs door het aantal liters: €2,00 ÷ 1 = €2,00 en €3,50 ÷ 2 = €1,75. Dan vergelijk je."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-005",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Koekjes: kleine doos (200 gram) voor €1,80 of grote doos (500 gram) voor €4,00. Welke is goedkoper per 100 gram?",
      "options": [
        "grote doos",
        "kleine doos",
        "beide even duur",
        "grote doos is duurder"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_weight",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per 100 gram berekenen",
            "content": "Kleine doos: €1,80 ÷ 2 = €0,90 per 100g. Grote doos: €4,00 ÷ 5 = €0,80 per 100g. €0,80 < €0,90 → grote doos is goedkoper per 100g.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken de prijs per 100 gram door de totaalprijs te delen door het gewicht in honderdtallen. Stap 1: kleine doos: €1,80 ÷ 2 (= 200g/100) = €0,90 per 100g. Stap 2: grote doos: €4,00 ÷ 5 (= 500g/100) = €0,80 per 100g. Stap 3: vergelijk: €0,80 < €0,90, dus de grote doos is goedkoper per 100 gram.",
        "distractorExplanations": {
          "0": "Correct! Grote doos: €4,00 ÷ 5 = €0,80 per 100g. Dat is 10 cent goedkoper per 100g.",
          "1": "Veelgemaakte fout: alleen naar de totaalprijs kijken. €1,80 is minder dan €4,00, maar per 100g is de kleine doos duurder: €0,90 vs. €0,80.",
          "2": "Veelgemaakte fout: denken dat het niet uitmaakt. €0,90/100g ≠ €0,80/100g. Dat is 10 cent verschil per 100 gram.",
          "3": "Veelgemaakte fout: alleen naar de totaalprijs kijken. De grote doos is duurder in totaal (€4,00 > €1,80), maar goedkoper per 100 gram (€0,80 < €0,90)."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-006",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "multiple_choice",
      "question": "Je wilt 10 potloden kopen. Losse potloden kosten €0,50. Een doos van 10 potloden kost €4,00. Hoeveel bespaar je met de doos?",
      "options": [
        "€1,00",
        "€0,50",
        "€1,50",
        "€4,00"
      ],
      "correctAnswer": 0,
      "conceptId": "price_comparison_bulk",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totale besparing berekenen",
            "content": "Losse prijs: 10 × €0,50 = €5,00. Doossprijs: €4,00. Besparing: €5,00 − €4,00 = €1,00.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: bereken eerst de totale losse prijs, dan trek je de doossprijs af. Stap 1: losse prijs voor 10 potloden: 10 × €0,50 = €5,00. Stap 2: doossprijs: €4,00. Stap 3: besparing = €5,00 − €4,00 = €1,00.",
        "distractorExplanations": {
          "0": "Correct! 10 × €0,50 = €5,00 los. Besparing: €5,00 − €4,00 = €1,00.",
          "1": "Veelgemaakte fout: de prijs van één potlood verwarren met de totale besparing. €0,50 is de prijs per stuk, niet de besparing. Besparing = 10 × €0,50 − €4,00 = €1,00.",
          "2": "Veelgemaakte fout: verkeerd aftrekken. 10 × €0,50 = €5,00. €5,00 − €4,00 = €1,00, niet €1,50. Controleer: €4,00 + €1,00 = €5,00 ✓.",
          "3": "Veelgemaakte fout: de doossprijs verwarren met de besparing. €4,00 is wat je betaalt voor de doos. Besparing = losse prijs − doossprijs = €5,00 − €4,00 = €1,00."
        }
      }
    },
    {
      "id": "TGL-GELD-KOOPJES-007",
      "familyId": "TGL-GELD-KOOPJES",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_vergelijken",
      "questionType": "number_sequence",
      "question": "Vul het ontbrekende bedrag in: €1,00, €1,50, €2,00, __, €3,00",
      "options": [
        "€2,50",
        "€2,25",
        "€2,75",
        "€3,50"
      ],
      "correctAnswer": 0,
      "data": {
        "sequence": [1.00, 1.50, 2.00, null, 3.00],
        "missingIndex": 3,
        "correctValue": 2.50
      },
      "interactiveConfig": {
        "sequence": ["€1,00", "€1,50", "€2,00", null, "€3,00"],
        "missingIndices": [3],
        "correctValues": ["€2,50", "2,50", "2.50"]
      },
      "conceptId": "money_pattern_sequence",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 4,
            "highlight": [1, 1.5, 2, 2.5, 3],
            "label": "Bedragen op een getallenlijn (in euro's)"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: zoek het patroon door het verschil tussen opeenvolgende bedragen te berekenen. Stap 1: €1,50 − €1,00 = €0,50. Stap 2: €2,00 − €1,50 = €0,50. Stap 3: het patroon is +€0,50 per stap. Stap 4: €2,00 + €0,50 = €2,50. Controle: €2,50 + €0,50 = €3,00 ✓.",
        "distractorExplanations": {
          "0": "Correct! Elke stap is +€0,50. €2,00 + €0,50 = €2,50.",
          "1": "Veelgemaakte fout: het verkeerde patroon zien. Het patroon is +€0,50 per stap (niet +€0,25). €2,00 + €0,50 = €2,50, niet €2,25.",
          "2": "Veelgemaakte fout: het verkeerde patroon zien. Het patroon is +€0,50 per stap (niet +€0,75). €2,00 + €0,50 = €2,50, niet €2,75.",
          "3": "Veelgemaakte fout: het getal ná €3,00 invullen in plaats van het ontbrekende getal. €3,50 = €3,00 + €0,50, maar het ontbrekende getal staat vóór €3,00: €2,00 + €0,50 = €2,50."
        }
      }
    }
  ]
}